export default __webpack_public_path__ + "static/media/Jerkin of the Amaranthine Drums.adbb58b5.jpg";